module.exports = __webpack_public_path__ + "static/hack-oregon-logo-acf323a1a422fb70993a4302f968026d.svg";